import { useCallback, useSyncExternalStore } from 'react'

function subscribeMediaQuery(query: string, onChange: () => void): () => void {
  if (typeof window === 'undefined') return () => {}
  const mql = window.matchMedia(query)
  // Safari < 14 used addListener/removeListener.
  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }
  mql.addListener(onChange)
  return () => mql.removeListener(onChange)
}

function mediaQueryMatches(query: string): boolean {
  return typeof window === 'undefined'
    ? false
    : window.matchMedia(query).matches
}

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => subscribeMediaQuery(query, onChange),
    [query]
  )
  const getSnapshot = useCallback(() => mediaQueryMatches(query), [query])
  return useSyncExternalStore(subscribe, getSnapshot, () => false)
}
